<template>
  <div id="headerBox" :style="{ height: headerCss.height + 'px', zoom: headerCss.zoom + '%' }">
    <div id="pcHeader">
      <div class="NavLeft">
        <div class="logoContant">
          <div class="tvuLogo cursor" :title="version"></div>
        </div>
        <div class="NavigationTop">
          <div class="Program">
            <div class="verticalMoulding"></div>
            <div class="backWorkbench">
              <div class="BackPaogram">
                <span>{{ $t('lang.tvuChannel') }}</span>
              </div>
            </div>
            <div id="navCommon" class="nav-common">
              <div :class="['tabTitle', {'router-link-active': RouterPath == '/po'}]" @click="GotoUrl('/po')">{{ $t("lang.Scheduler") }}</div>
              <div :class="['tabTitle', {'router-link-active': RouterPath == '/pop'}]" @click="goToLogin('welcomeControl')">{{ $t("lang.Playout") }}</div>
              <!-- <router-link to="pt">{{ $t("lang.Template") }}</router-link> -->
            </div>
          </div>
        </div>
      </div>
      <div class="operateR">
        <div class="GoLive cursor" @click="goLive">
          <i class="iconfont icon-Shutdown"></i>
          <span>{{ $t('lang.goLive') }}</span>
        </div>
        <div class="questionMarK" @click="QuestionIframe = true">
          <i class="iconfont icon-help"></i>
        </div>
        <!-- 录制弹出框 -->
        <div class="StatusPop" @click="goToLogin('welcomeHeaderRecording')">
          <i class="iconfont icon-Message"></i>
        </div>
        <div class="language">
          <span class="cursor" v-if="langSelt == 'en'" @click="changeLangEvent('zh')">EN</span>
          <span class="cursor" v-if="langSelt == 'zh'" @click="changeLangEvent('en')">中</span>
        </div>
        <el-button type="success" size="mini" style="margin: 0 15px;" @click="goToLogin('welcomeSignIn')">{{ $t('lang.signIn') }}</el-button>
        <img @click="goToLogin('welcomeTvuServiceList')" class="cursor" src="../../assets/img/items_nav_icon.png">
      </div>
      <div class="PushWrap" v-if="GoLive">
        <div class="formTitle">
          <i class="closeBtn el-icon-close" @click="GoLive = false"></i>
        </div>
        <ul class="outputExample">
          <li class="imgItem">
            <svg class="svgicon" aria-hidden="true">
              <use xlink:href="#icon-facebook2"></use>
            </svg>
          </li>
          <li class="imgItem">
            <svg class="svgicon" aria-hidden="true">
              <use xlink:href="#icon-youtubeautored"></use>
            </svg>
          </li>
          <li class="imgItem">
            <svg class="svgicon" aria-hidden="true">
              <use xlink:href="#icon-Rtmpgreen"></use>
            </svg>
          </li>
        </ul>
        <div class="Add" @click="goToLogin('welcomeAddOutPut')">
          <i class="iconfont icon-add"></i>{{ $t('lang.SocialOutputs') }}
        </div>
      </div>
    </div>
    <div class="QuestionIframe" v-if="QuestionIframe">
      <div class="Iframeclose">
        <i @click="QuestionIframe = false" class="el-icon-close"></i>
      </div>
      <div class="Iframe">
        <iframe src="https://www.tvunetworks.com/tip/how-to-schedule-a-program-in-tvu-channel/" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import { creatAccount } from '@/assets/js/common/creatAccount.js'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'

export default {
  name: 'HeaderCc',
  computed: mapState({
    StateObj: (state) => state,
    pageRequest: (state) => state.websocket.pageRequest,
    pageRWebsocket: (state) => state.websocket.pageRWebsocket
  }),
  created () {
    if (this.timingGetVM) clearInterval(this.timingGetVM)
    // 切换program
    // Bus.$on('SwitchProgram', (data) => {
    //   this.getProgramName()
    // })
    this.IsEnterProgram(this.$route.path)

    $(window).bind('hashchange', () => {
      this.toggleHeaderMobMenu = false
      $('#pro_nav_icon_bg').show()
    })
    $(window).resize(() => {
      if ($(window).width() > 1024) {
        $('#pro_nav_icon_bg').show()
      } else if (this.toggleHeaderMobMenu) {
        $('#pro_nav_icon_bg').hide()
      }
    })
  },
  mounted () {
    if (this.langSelt.includes('zh')) {
      this.changeLangEvent('zh')
    } else {
      this.changeLangEvent('en')
    }
  },
  data () {
    return {
      QuestionIframe: false,
      GoLive: false,
      // 定时任务获取vm
      timingGetVM: null,
      // 时间上限
      timeLimit: 0,
      RouterPath: '',
      // 本人信息
      SelfMessage: {},
      // 显示更多用户信息
      ShowUser: false,
      // 所有program成员信息
      AllMemberList: [],
      // Program信息
      ProgramId: '',
      ProgramName: '',
      // 用户颜色
      UserColor: {
        0: 'rgb(15, 190, 113)',
        1: 'rgb(70, 201, 225)',
        2: 'rgb(47, 141, 244)',
        3: 'rgb(255, 197, 115)',
        4: 'rgb(255, 106, 146)',
        5: 'rgb(255, 192, 0)',
        6: 'rgb(146, 72, 199)'
      },
      isPromptAlert: true,
      activeIndex: '1',
      menuList: [],
      headerCss: {
        height: this.height || 80,
        zoom: 0
      },
      langOps: {
        height: 28,
        width: 95,
        bg: '#424242',
        color: '#fff'
      },
      langSelt: navigator.language || navigator.userLanguage, // 获取当前浏览器语言
      setGridNumTimer: null, // 向Grid标签添加数量显示的定时器
      more10S: 1, // 超过10次清除定时器
      supportViewAccount: null, // 这个数组有数据代表,是support通过setting页面monitor操作用户跳转过来的 =>
      startLiveAlert: true,
      stopLiveAlert: true,
      alertTime: 1,
      setAlertNumTimer: null, // 向Grid标签添加数量显示的定时器
      // 判断是否是workbench
      judgeWorkbench: true,
      // 版本号
      version: ''
    }
  },
  props: ['height', 'background'],
  watch: {
    // 监听路由跳转
    $route (to, from) {
      this.IsEnterProgram(to.path)
    }
  },
  methods: {
    goLive () {
      this.GoLive = true
      playoutAnalyze('welcomeGoLive')
    },
    goToLogin () {
      creatAccount()
    },
    goToIframe () { },
    changeLangEvent (langSelt) {
      window.localStorage.setItem('lang', langSelt)
      langConfig.changeLangCookie(langSelt)
      this.langSelt = langSelt
      this.$i18n.locale = langConfig.langValue
      console.log(langConfig.langValue, '333333')
    },
    // 判断权限
    Jurisdiction (tabPrefix, path) {
      const ProgramRMessage = Outil.getProgramReceiver().ProgramId
      this.axios.post(Outil.getUrl('/programTeamMember/openPlayout'), {
        programId: ProgramRMessage,
        tabPrefix
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.$router.push({ path })
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
            this.$router.push({
              path: 'po'
            })
          }
        }
      }).catch()
    },
    // 判断是否进入program
    IsEnterProgram (path) {
      this.RouterPath = path
      // this.ProgramId = this.$BehaviorSyns.getProgramId()
      // if (path == '/wb' || !this.ProgramId) {
      //   this.judgeWorkbench = true
      //   this.AllMemberList = []
      //   this.SelfMessage = {}
      // } else {
      //   this.judgeWorkbench = false
      //   const ProgramMessage = Outil.getProgramReceiver()
      //   if (ProgramMessage.ProgramStatus == 2) {
      //     this.$message({
      //       message: this.$t('lang.FirstOpenChannel'),
      //       type: 'warning'
      //     })
      //     ProgramMessage.ProgramStatus = 1
      //     localStorage.setItem('ProgramRMessage', JSON.stringify(ProgramMessage))
      //   }
      //   this.AllMember()
      // }
    },
    // 监听上下线
    LineStatus () {
      // 行为同步 上下线通知
      Bus.$on('programOnlineChange', (data) => {
        console.log('header')
        if (typeof data != 'object') {
          return
        }
        if (data.action == 'programOnlineModule') {
          this.AllMember()
        }
      })
    },
    // 获取program名字
    getProgramName () {
      this.$nextTick(() => {
        const ProgramRMessage = Outil.getProgramReceiver()
        if (ProgramRMessage) {
          this.ProgramName = ProgramRMessage.ProgramName
        }
      })
    },
    // 跳转页面
    GotoUrl (path) {
      if (path == '/po') {
        this.$router.push({ path })
      } else {
        const channelInitConfig = localStorage.getItem('channelInitConfig') && JSON.parse(localStorage.getItem('channelInitConfig'))
        const programTabPrefix = channelInitConfig && channelInitConfig.urlInfo.programTabPrefix
        this.Jurisdiction(programTabPrefix.playoutTabPrefix, path)
      }
    },
    // 跳转workbench页面
    backWorkbench () {
      this.$router.push({ path: '/wb' })
    },
    // program的所有成员
    AllMember () {
      const channelInitConfig = localStorage.getItem('channelInitConfig') && JSON.parse(localStorage.getItem('channelInitConfig'))
      const programTabPrefix = channelInitConfig && channelInitConfig.urlInfo.programTabPrefix
      this.ProgramId = this.$BehaviorSyns.getProgramId()
      let tabPrefix
      // 判断不同页面查询不同用户
      if (this.$route.path == '/pop') {
        tabPrefix = programTabPrefix.playoutTabPrefix
      } else if (this.$route.path == '/po') {
        tabPrefix = programTabPrefix.scheduleTabPrefix
      }
      this.axios.post(Outil.getUrl('/programTeamMember/listMember'), {
        programId: this.ProgramId,
        tabPrefix
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            if (this.StateObj.common.baseUserInfo) {
              this.AllMemberList = res.data.result.filter((item) => {
                if (this.StateObj.common.baseUserInfo.id != item.userId) {
                  item.Color = this.UserColor[Math.floor(Math.random() * 6)]
                } else {
                  this.SelfMessage = item
                }
                return this.StateObj.common.baseUserInfo.id != item.userId && item.online
              })
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      }).catch()
    },
    // 显示弹出框
    ShowPop () {
      this.$emit('ShowPop', true)
    },
    // 转换名字
    TranslateName (name) {
      if (typeof name == 'string') {
        return name.substr(0, 2)
      } else {
        return name
      }
    },
    getPromptMsgCont () {
      this.axios({
        method: 'post',
        url: '/gatewayPlayoutUrl/tvu-playout/extra/listPreference',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        data: {}
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          // this.isPromptAlert = res.data.result && res.data.result[0] && res.data.result[0].content;
          if (res.data.result.length > 0) {
            const list = res.data.result
            list.forEach((v) => {
              if (v.pn == 'startTransmission') {
                if (v.content == 'false') {
                  this.startLiveAlert = false
                } else {
                  this.startLiveAlert = true
                }
              }
              if (v.pn == 'stopTransmission') {
                if (v.content == 'false') {
                  this.stopLiveAlert = false
                } else {
                  this.stopLiveAlert = true
                }
              }
              if (v.pn == 'aleartMessage') {
                if (v.content == 'false') {
                  this.isPromptAlert = false
                } else {
                  this.isPromptAlert = true
                }
              }
            })
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch()
    },
    getStartStopAlert (v) {
      const params = {
        pn: 'startTransmission'
      }
      params.pn = v == 'stop' ? 'startTransmission' : 'stopTransmission'
    },
    updateAccount (data) {
      const supportViewAccount = window.sessionStorage.getItem('userChangeInfo')
      if (supportViewAccount && JSON.parse(supportViewAccount)) {
        this.supportViewAccount = JSON.parse(supportViewAccount)
        this.$nextTick(() => {
          if (this.$refs.logoutBtn) {
            this.$refs.logoutBtn.show()
          }
        })
        this.$forceUpdate()
      } else {
        this.$nextTick(() => {
          if (this.$refs.logoutBtn) {
            this.$refs.logoutBtn.hide()
          }
        })
        this.supportViewAccount = null
      }
    },
    getVersion (type) {
      const programId = type ? '' : this.$BehaviorSyns.getProgramId()
      if (this.timingGetVM) clearInterval(this.timingGetVM)
      this.getVersionRequest(programId)
      if (programId) {
        this.timeLimit = 0
        this.timingGetVM = setInterval(() => {
          this.timeLimit++
          if (this.timeLimit > 20) {
            clearInterval(this.timingGetVM)
          }
          this.getVersionRequest(programId)
        }, 20000)
      }
    },
    getVersionRequest (programId) {
      this.axios.get(`/gatewayPlayoutUrl/tvu-playout/version/info/get?programId=${programId}`).then((res) => {
        if (res.data.errorCode == '0x0') {
          const { result } = res.data
          const ImageVersion = result.cloudReceiverVersion ? `/VM ImageVersion: ${result.cloudReceiverVersion}` : ''
          this.version = `UI：${window.localStorage.getItem('newChannelVersion')}/Backend: ${result.applicationName}-${result.buildVersion}${ImageVersion}`
          if (result.cloudReceiverVersion && this.timingGetVM) {
            clearInterval(this.timingGetVM)
          }
        } else {
          this.version = `UI：${window.localStorage.getItem('newChannelVersion')}`
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      })
    },
    // 退出登入
    logout (options) {
      if (options === 'logout') {
        this.axios.get('/gatewayPlayoutUrl/tvu-playout/user/logout').then((res) => {
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            window.localStorage.setItem('channelSession', '')
            window.sessionStorage.setItem('userChangeInfo', '')
            localStorage.removeItem('ProgramRMessage')
            sessionStorage.setItem('switchAccount', 'false')
            window.location.href = `${window.location.protocol}//${res.data.result.redirectUrl}`
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch()
      } else if (options == 'changeToSupport') {
        this.$confirm(this.$t('lang.gotoSupportTips'), '', {
          cancelButtonText: this.$t('lang.cancel'),
          confirmButtonText: this.$t('lang.i18n_confirm'),
          cancelButtonClass: 'btn-custom-cancel',
          type: 'warning',
          iconClass: 'myIcon'
        }).then(() => {
          const supportSession = this.supportViewAccount.supportUserInfo.session // 将要跳转的support的session
          const supportCookie = this.supportViewAccount.supportUserInfo.cookieSet // 将要跳转的support的cookie
          let pathKey = 'st'
          if (this.$route.path == '/st') {
            pathKey = 'stS'
          }
          // location = location + '/#/' + pathKey + '?session=' + supportSession;
          window.sessionStorage.setItem('userChangeInfo', '')
          window.localStorage.setItem('channelSession', supportSession)
          window.document.cookie = supportCookie // 设置cookie
          sessionStorage.setItem('switchAccount', 'true')
          // window.location.href = location; //更换session 刷新页面
          this.$router.push({
            path: `/${pathKey}`,
            query: {
              session: supportSession
            }
          })
        })
      }
    }
  },
  beforeDestroy () {
    console.log('header11111')
    if (this.timingGetVM) clearInterval(this.timingGetVM)
    Bus.$off('programOnlineChange')
    Bus.$off('SwitchProgram')
  }
}
</script>
<style scoped lang="less">
.supportChangeColor {
  color: #121212;
}

.supportDis {
  height: 45px;
  line-height: 45px;
  display: block;
  cursor: pointer;
}

.border {
  border-bottom: 1px solid #444;
}
#pcHeader {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  .NavLeft {
    display: flex;
    width: 100%;
  }
  .NavigationTop {
      .Workbench {
        width: 80px;
        height: 19px;
        font-size: 16px;
        font-weight: bold;
        color: #252525;
        line-height: 80px;
        margin-left: 56px;
      }
      .Program {
        width: 800px;
        display: flex;
        align-items: center;
        .verticalMoulding {
          width: 1px;
          height: 32px;
          background: #444444;
          margin-right: 36px;
        }
        .backWorkbench {
          // width: 320px;
          height: 19px;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          line-height: 19px;
          text-align: left;
          .BackPaogram {
            display: flex;
            align-items: center;
            cursor: pointer;
            span {
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
  }
  .operateR {
    display: flex;
    align-items: center;
    // margin-right: 70px;
    .GoLive{
      margin-right: 22px;
      width: 90px;
      height: 30px;
      border-radius: 13px;
      border: 1px solid #33ab4f;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 8px;
      i{
        color: #58AF38;
        margin-right: 5px;
      }
      span{
        color: #fff;
      }
    }
    .questionMarK{
        margin-right: 22px;
      i {
        font-size: 22px;
        color: #fff;
      }
    }
    .StatusPop {
      margin-right: 22px;
      i {
        font-size: 22px;
        color: #fff;
      }
    }
    .language{
      width: 25px;
      height: 25px;
      border-radius: 50%;
      line-height: 25px;
      background: #DBDBDB;
      font-size: 12px;
      color: #121212;
    }
  }

  .slotBox {
    position: relative;
    top: 50%;
    transform: translateY(-50%);

    div {
      font-size: 22px;
      font-weight: bold;
      color: #fff;
      text-align: left;
      // width:200px;
    }
  }
  .usrBox {
    padding-right: 75px;

    .userBtn {
      width: 65px;
      height: 45px;
      background: url("../../assets/img/user.png") no-repeat;
      display: inline-block;

      i {
        font-size: 18px;
        margin-left: 45px;
        font-weight: bold;
        margin-top: 12px;
        color: #fff;
      }
    }
  }
  .PushWrap{
    position: absolute;
    top: 90px;
    right: 12px;
    width: 363px;
    height: 212px;
    z-index: 10000;
    background: #111111;
    .formTitle{
      text-align: right;
      margin-top: 20px;
      i {
        font-size: 24px;
        color: #999999;
        margin-right: 20px;
      }
    }
    .outputExample {
      width: 363px;
      height: 85px;
      margin-bottom: 0;
      padding: 0 40px ;
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      opacity: .5;
      .imgItem {
        // padding: 0 20px;
        text-align: center;
        .svgicon {
          width: 60px;
          height: 66px;
        }
      }
    }
    .Add {
      font-size: 14px;
      color: #33ab4f;
      text-align: left;
      margin-top: 25px;
      i {
        font-size: 14px;
        color: #33ab4f;
        margin-left: 24px;
        margin-right: 10px;
      }
    }
  }
}
#navCommon {
  width: 380px;
  height: 80px;
  line-height: 80px;
  margin-left: 80px;
  display: flex;
  justify-content: flex-start;
  .tabTitle {
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    // display: flex;
    align-self: center;
    height: 60px;
    line-height: 60px;
    cursor: pointer;
    list-style: none;
    position: relative;
    transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    white-space: nowrap;
    margin: 0 25px;
    display: inline-block;
    line-height: 60px;
  }
  .router-link-active {
    color: #58af38;
  }
}
.QuestionIframe {
  position: fixed;
  top: 80px;
  left: 50%;
  width: 800px;
  height: 750px;
  margin-left: -400px;
  background: #ffffff;
  z-index: 10000;
  .Iframeclose {
    width: 800px;
    height: 50px;
    padding-right: 20px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .el-icon-close {
      color: #999999;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .Iframe {
    height: 697px;
  }
}

/*覆盖elemen-ui drop样式*/
.el-dropdown {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

[v-cloak] {
  display: none !important;
}
</style>
<style lang="less">
.alert_message_box.el-notification {
  background-color: #444;
  box-shadow: 0px 0px 15px #100400;
  border: none;
  .el-notification__icon.el-icon-warning {
    color: #dc4e39;
    font-size: 20px;
  }
  .el-notification__title,
  .el-notification__content,
  .el-notification__closeBtn.el-icon-close {
    color: #fff;
  }
  .el-notification__title {
    width: 250px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .el-notification__content {
    width: 250px;
    > p > div > span {
      float: left;
    }
    > p > div > span:nth-child(2) {
      width: 225px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
.alert_icon {
  position: absolute;
  top: 0;
  right: -20px;
  background-color: #f57c00;
  text-align: center;
  color: #fff;
  width: 19px;
  height: 19px;
  line-height: 19px;
  border-radius: 9.5px;
  padding: 0;
  font-size: 12px;
}
</style>
